import { getCompatibleAuthTokenHttp } from 'src/services/utils/enhancedAuthTokenHttp';
import { isMockServices } from 'src/utils';
import mock from 'src/services/utils/mock';
import { MutationFunction } from '@tanstack/react-query';
import { LoanMapping } from './getLoanMappings';

export interface BulkUpdateLoanMappingsParams {
  loanId: string;
  type: string;
  mappings: Array<{
    id?: string;
    mapping: {
      target_folder: string;
      document_ids: string[];
    };
  }>;
}

export interface BulkUpdateLoanMappingsResponse {
  success: boolean;
  loanMappings: LoanMapping[];
  message: string;
}

const bulkUpdateLoanMappings: MutationFunction<
  BulkUpdateLoanMappingsResponse,
  BulkUpdateLoanMappingsParams
> = async (args) => {
  if (isMockServices()) return await mock(_mockData);

  const authTokenHttp = await getCompatibleAuthTokenHttp();
  const response = await authTokenHttp<BulkUpdateLoanMappingsResponse>(
    `/loans/${args.loanId}/loan-mappings/bulk`,
    {
      method: 'PUT',
      body: {
        type: args.type,
        mappings: args.mappings,
      },
    },
  );

  if (response.data) return response.data;
  throw new Error('Failed to update loan mappings');
};

export default bulkUpdateLoanMappings;

const _mockData: BulkUpdateLoanMappingsResponse = {
  success: true,
  loanMappings: [],
  message: 'Loan mappings updated successfully',
};
